import * as React from 'react';
import { FC } from 'react';

import { useIntl } from 'react-intl';

import LoadingAnimation from 'components/loading-animation';
import { ResponsiveCarousel } from 'components/responsive-carousel';
import { LockedOffersCard } from 'components/rewards/locked-offers-card';

import { SingleWrapper, Wrapper } from './locked-offers.styled';
import { ILockedOffersViewProps } from './types';
import { cardAttributes } from './utils';

export const LockedOffersView: FC<ILockedOffersViewProps> = ({ isLoading, offers, onClick }) => {
  const { formatMessage } = useIntl();
  if (isLoading) {
    return <LoadingAnimation fillColor={Styles.color.primary} />;
  }
  if (!offers || !offers.length) {
    return null;
  }

  const lockedoffers = offers?.map((offer, index) => {
    // TODO add loading state
    const { mode, header, description, expiresText } = cardAttributes(offer, formatMessage);

    return (
      <LockedOffersCard
        key={`${description}-${index}`}
        header={header || null}
        subheader={description || null}
        expiresText={expiresText}
        stepsCompleted={offer.stepsCompleted}
        offerState={offer.offerState}
        progressData={offer.steps}
        mode={mode}
        onClick={() => onClick(offer)}
      />
    );
  });

  if (offers.length === 1) {
    // TODO: Check against TH brand styles
    return (
      <SingleWrapper data-testid="locked-offers-view-wrapper">{lockedoffers[0]}</SingleWrapper>
    );
  }
  return (
    <Wrapper data-testid="locked-offers-view-wrapper">
      <ResponsiveCarousel>{lockedoffers}</ResponsiveCarousel>
    </Wrapper>
  );
};
